export default

	props:
		product: Object
		tag: # tag as prop. Use 'li' where appropriate.
			type: String
			default: 'div'
